export const FIELDS = [
  'id',
  'title',
  'subtitle',
  'authors',
  'publisher',
  'publishedDate',
  'description',
  'pageCount',
  'categories',
  'averageRating',
  'smallThumbnail',
  'mediumImage',
  'largeImage',
  'thumbnail',
  'language',
  'previewLink',
  'infoLink',
  'saleability',
  'isEbook',
  'viewability',
  'epubacsTokenLink',
  'pdfdownloadlink',
  'webReaderLink'
];



// WEBPACK FOOTER //
// ./src/data/fields.js